import { Component, OnInit, ViewChild, OnChanges } from '@angular/core';
import { NavigationExtras, Router } from '@angular/router';
import { Colmodel, GridFIlterType } from 'src/app/modules/commongrid/colmodel.model';
import { CommongridComponent } from 'src/app/modules/commongrid/commongrid.component';
import { PatientRegisterService } from '../patient-registration/services/patient-register.service';
import { RppRenewListService } from '../rpp-renew-list/rpp-renew-list.service';
import { RppViewListService } from './rpp-view-list.service';
import { RPPPatientMappingService } from '../rpp-patient-allocate/services/rpp-patient-mapping.service';
import { LoaderService, UtilsService } from 'src/app/modules/shared/services';
import { CSR_STATUS } from '../registration/demographics/demographics.component';



@Component({
  selector: 'app-rpp-view-list',
  templateUrl: './rpp-view-list.component.html',
  styleUrls: ['./rpp-view-list.component.scss']
})
export class RppVieweListComponent implements OnInit {
  cols: Colmodel[] = [];
  currentPage = 1;
  disableSearch = true;
  public contactNumber: any = '';
  isModalOpen: boolean = false;
  isInductionModalOpen: boolean = false;
  patientPackageDetails: any;
  patientInductionDetails: any;
  selectedPatient: any;
  isPatientStatusActive: string = 'Active';

  @ViewChild(CommongridComponent) dataGrid: CommongridComponent;
  @ViewChild('payTemplate', { static: true }) payTemplate;
  @ViewChild('actionTemplate', { static: true }) actionTemplate;
  @ViewChild('statuTemplate', { static: true }) statuTemplate;
  @ViewChild('nvfStatus', { static: true }) nvfStatus;
  @ViewChild('csrTemp', { static: true }) csrTemp;
  @ViewChild('patientStatus', { static: true }) patientStatus;
  @ViewChild('patientTimeline', { static: true }) patientTimeline;
  @ViewChild('packageDetails', { static: true }) packageDetails;
  @ViewChild('consentFormFilledTemp', { static: true }) consentFormFilledTemp;
  @ViewChild('wearableStatusTemp', { static: true }) wearableStatusTemp;
  @ViewChild('assesmentStatusTemp', { static: true }) assesmentStatusTemp;
  @ViewChild('inductionDoneTemp', { static: true }) inductionDoneTemp;

  constructor(
    public viewService: RppViewListService, 
    private patientRegisterService: PatientRegisterService,
    private rppPatientMappingService: RPPPatientMappingService,
    public route: Router,
    private utilService: UtilsService,
    private loaderService: LoaderService
  ) {}

  ngOnInit(): void {
    this.cols = [
      new Colmodel('serial_num', 'Sr No', false, true, false),
      new Colmodel('patient_ref_id', 'Patient Id', false, true, false, { filtertype: GridFIlterType.INPUT }),
      new Colmodel('patient_id', 'Id', false, true, true, { filtertype: GridFIlterType.INPUT }),
      new Colmodel('', 'Session Details', false, true, false, { filtertype: GridFIlterType.NONE, formatterTemplateRef: this.packageDetails }),
      new Colmodel('patient_name', 'Patient Name', false, true, false, { filtertype: GridFIlterType.INPUT }),
      new Colmodel('mobile_number', 'Mobile Number', false, true, false, { filtertype: GridFIlterType.INPUT }),
      new Colmodel('package_name', 'Plan Name', false, true, false, { filtertype: GridFIlterType.INPUT }),
      new Colmodel('induction_done', 'Induction Status', false, false, false, { filtertype: GridFIlterType.NONE, formatterTemplateRef: this.inductionDoneTemp }),
      new Colmodel('enrollment_date', 'Enrollment Date', false, true, false, { filtertype: GridFIlterType.INPUT }),
      new Colmodel('due_date', 'Due Date', false, true, false, { filtertype: GridFIlterType.INPUT }),
      new Colmodel('registration_date', 'Date of Registration', false, true, false, { filtertype: GridFIlterType.INPUT }),
      new Colmodel('psychiatrist', 'Psychiatrist', false, true, false, { filtertype: GridFIlterType.INPUT }),
      new Colmodel('psychologist', 'Psychologist', false, true, false, { filtertype: GridFIlterType.INPUT }),
      new Colmodel('feedback_assignment', 'Feedback Counsellor', false, true, false, { filtertype: GridFIlterType.INPUT }),
      new Colmodel('CaseReviewCommentsCount', 'Review Comments', false, true, false, { filtertype: GridFIlterType.INPUT }),
      new Colmodel('activity_assignment', 'Actvity Counsellor', false, true, false, { filtertype: GridFIlterType.INPUT }),
      new Colmodel('pd_assignment', 'Form 5 (Diagnosis Completed)', false, true, false, { filtertype: GridFIlterType.INPUT }),
      // new Colmodel('service_details', 'Service Assigned', false, true, false, {filtertype: GridFIlterType.INPUT}),
      // new Colmodel('action', 'Actions', false, false, this.disableColumn, {filtertype: GridFIlterType.NONE, formatterTemplateRef: this.actionTemplate}),
      new Colmodel('status', 'Status', false, true, false, { filtertype: GridFIlterType.INPUT }),
      new Colmodel('csr_id', 'CSR', false, true, false, { filtertype: GridFIlterType.INPUT, formatterTemplateRef: this.csrTemp }),
      new Colmodel('is_nvf_facility', 'NVF Status', false, true, false, { filtertype: GridFIlterType.INPUT, formatterTemplateRef: this.nvfStatus }),
      new Colmodel('assesment_status', 'Assessment Status', false, true, false, { filtertype: GridFIlterType.INPUT, formatterTemplateRef: this.assesmentStatusTemp }),
      new Colmodel('wearable_status', 'Wearable Status', false, true, false, { filtertype: GridFIlterType.INPUT, formatterTemplateRef: this.wearableStatusTemp }),
      new Colmodel('wearable_last_comment', 'Wearable Last Comment', false, true, false, { filtertype: GridFIlterType.INPUT }),
      new Colmodel('isConsentFormFilled', 'Consent Form Filled', false, true, false, { filtertype: GridFIlterType.INPUT, formatterTemplateRef: this.consentFormFilledTemp }),
      new Colmodel('date_consent_created', 'Consent Date', false, true, false, { filtertype: GridFIlterType.INPUT }),
      new Colmodel('comments', 'Comments', false, true, false, { filtertype: GridFIlterType.INPUT }),
      new Colmodel('patient_status', 'Patient Status', false, true, false, { filtertype: GridFIlterType.NONE, formatterTemplateRef: this.patientStatus}),
      new Colmodel('', 'Timeline', false, true, false, { filtertype: GridFIlterType.NONE, formatterTemplateRef: this.patientTimeline })
    ];
    this.getPatientGridData()
  }

  getPatientGridData(patientStatus: string = 'Active') {
    this.isPatientStatusActive = patientStatus;
    const tempPayload = {
      page_size: this.dataGrid && this.dataGrid.rows ? this.dataGrid.rows : 50,
      current_page: this.currentPage,
      patientStatus: this.isPatientStatusActive
    };
    this.viewService
      .getPatientRPPViewGridDetails(tempPayload)
      .subscribe((res: any) => {

        const rppMappingData = res.data.
        map((patient, index) => ({
          ...patient,
          activity_assignment: patient?.activity_assignment || 'N/A',
          pd_assignment: patient?.pd_assignment || 'N/A',
          wearable_last_comment: patient?.wearable_last_comment || 'N/A',
          date_consent_created: patient?.date_consent_created || 'N/A',
          comments: patient?.comments || 'N/A',
          psychiatrist: patient?.psychiatrist || 'N/A',
          psychologist: patient?.psychologist || 'N/A',
          feedback_assignment: patient?.feedback_assignment || 'N/A'
        }));

        this.dataGrid.data = rppMappingData;
        this.dataGrid.totalRecords = res.count;
      });
  }

  keyPressNumbers(event) {
    var charCode = (event.which) ? event.which : event.keyCode;
    this.disableSearch = this.contactNumber.length >= 9 ? false : true;
    // Only Numbers 0-9
    if ((charCode < 48 || charCode > 57)) {
      event.preventDefault();
      return false;
    } else {
      return true;
    }
  }

  onFocusOutEvent(event) {
    this.disableSearch = this.contactNumber.length >= 10 ? false : true;
    if (this.disableSearch) {
      this.getPatientGridData()
    }
  }
  searchWithPhoneNumber() {
    if (this.contactNumber == "") {
      this.getPatientGridData()
    }
    let payload =
    {
      search_keyword: this.contactNumber,
    }
    this.patientRegisterService.findbyMobileNumberRppViewList(payload).subscribe((res: any) => {
      this.dataGrid.data = res.data;
      this.dataGrid.totalRecords = res.count;
    })
  }

  exportCSV() {
    let filename = 'RPP List'
    let payload = {
    }

    this.viewService.exportCSV().subscribe((res: any) => {
      const blob: any = new Blob([res], { type: 'text/csv' });
      const link = document.createElement('a');
      if (link.download !== undefined) {
        const url = URL.createObjectURL(blob);
        link.setAttribute('href', url);
        link.setAttribute('download', filename);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }
    })
  }
  onCustomFilter(event) {
    this.dataGrid.totalRecords = event.data.length;
  }
  OnChanges() {

  }
  onPageChangeEvent(event) {
    this.currentPage = event.first == 0 ? 1 : (event.first / event.rows) + 1;
    this.dataGrid.rows = event.rows;
    // const payload = {filters: event.filters};
    const payload = { limit: true };
    this.getPatientGridData();
  }

  onCustomrowSelect(event) {
    const navigationExtras: NavigationExtras = {
      state: { editData: JSON.stringify(event) },
    };
    this.route.navigate([`/rpp-list/patient-dashboard/${event.patient_id}`], navigationExtras)
  }

  handleGetPatientPackageDetails(patient_id: any, event: any) {
    event.stopPropagation();
    this.rppPatientMappingService.getPatientDashboardDetails({patient_id}).subscribe({
      next: res => {
        if(res) {
          this.isModalOpen = true;
          this.patientPackageDetails = res;
        } else {
        this.utilService.showErrorToast('No Package Details Found.');
        }
      },
      error: err => {
        this.utilService.showErrorToast('Error Fetching Patient Package Details.');
      }
    })
  }

  onInductionDoneChange(event: any) {
    if(event) {
      this.isInductionModalOpen = false;
      this.getPatientGridData();
    }
  }

  handleGetInductionDetails(gridData: any, event: any) {
    const patientDetails = gridData;
    event.stopPropagation();
    this.loaderService.isLoading.next(true);
    this.rppPatientMappingService.getInductionDetails(patientDetails?.patient_id).subscribe({
      next: (res: any) => {
        if(res) {
          this.loaderService.isLoading.next(false);
          this.isInductionModalOpen = true;
          const patientData = res.data;
          patientData['patientName'] = patientDetails?.patient_name;
          this.patientInductionDetails = patientData;
          this.selectedPatient = gridData;
        } else {
          this.loaderService.isLoading.next(false);
        this.utilService.showErrorToast('No Data Found.');
        }
      },
      error: err => {
          this.loaderService.isLoading.next(false);
        this.utilService.showErrorToast('Error Fetching Induction Details.');
        }
    },
  )
  }

  handleGetPatientTimeline(patientId: any, event: any) {
    event.stopPropagation();
    this.route.navigate([`/rpp-list/timeline/${patientId}`])
  }

  handleGetCsr(gridData: any): string {
      if (!gridData || typeof gridData !== 'object') return '-';
  
      const { csr_id, csr } = gridData;
  
      if (csr_id === CSR_STATUS.REGULAR_VALUE) {
        return CSR_STATUS.REGULAR_LABEL;
      }
  
      if (csr && (csr.shortName || csr.name)) {
        return `${csr.shortName ?? ''}`.trim();
      }
  
      return '-';
  }

}